import { API } from "../api/axios";
const END_POINT = "/categorys";
const END_POINT_CATEGORIE ="/category"

class CategorieService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
    get(id){
        return API.get(`${END_POINT_CATEGORIE}/${id}`)
    }
    delete(id) {
        return API.delete(`${END_POINT_CATEGORIE}/${id}`);
    }
    create(data) {
        return API.post(END_POINT_CATEGORIE, data);
    }
    update(id, data) {
        return API.post(`${END_POINT_CATEGORIE}/${id}`, data);
    }
}

export default new CategorieService();
